import _ from 'lodash';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { BiDownArrowAlt } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import AccountTypeEnum from '~Api/Investor/AccountTypeEnum';
import IInvestor from '~Api/Investor/IInvestor';
import { currentInvestorGetAction, monthlyStatementsListAction } from '~Investor/actions';
import { currentInvestorSelector, monthlyStatementsSelector } from '~Investor/selectors';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import IMonthlyStatement from '~Api/Investor/IMonthlyStatement';
import moment from 'moment';
import Pagination from '~UI/Pagination';

export default function MonthlyStatements(): ReactElement {
    const [ currentPage, setCurrentPage ] = useState<number>(1);
    const [ perPage ] = useState<number>(3);

    const currentInvestor: IInvestor = useSelector(currentInvestorSelector);
    const monthlyStatements: IDictionary<IMonthlyStatement> = useSelector(
        (state: IGlobalState) => monthlyStatementsSelector(state, AccountTypeEnum.IncomeTrust),
    );

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!currentInvestor) {
            dispatch(currentInvestorGetAction());
        }
    }, []);

    useEffect(() => {
        if (!monthlyStatements) {
            dispatch(monthlyStatementsListAction(AccountTypeEnum.IncomeTrust));
        }
    }, []);

    const onClickPage: (page: number) => void = useCallback((page: number) => {
        setCurrentPage(page);
    }, []);

    if (!monthlyStatements || !currentInvestor) {
        return (
            <div className='content-box'>
                <Spinner animation='border' />
            </div>
        );
    }

    if (_.isEmpty(monthlyStatements)) {
        return (
            <div className='content-box'>
                <h2>Monthly Statements</h2>
                <p>No monthly statements are available for your account yet.</p>
            </div>
        );
    }

    const offset: number = (currentPage - 1) * perPage;
    const pageMonthlyStatements: IMonthlyStatement[] = _.values(monthlyStatements).slice(offset, offset + perPage);

    const statementsBlock: JSX.Element[] = _.map(_.orderBy(pageMonthlyStatements, [ 'year' ], [ 'desc' ]), (monthlyStatement: IMonthlyStatement) => (
        <Button
            href={`${process.env.API_HOST}/investor-account-monthly-statements/${monthlyStatement.uuid}/download`}
            target='_blank'
        >
            {moment(monthlyStatement.month).format('MMMM')} {monthlyStatement.year} Monthly Statement <BiDownArrowAlt />
        </Button>
    ));

    return (
        <div className='content-box'>
            <h2>Monthly Statements</h2>
            {statementsBlock}
            <div className='pagination-block'>
                <Pagination
                    currentPage={currentPage}
                    itemCount={_.values(monthlyStatements).length}
                    onClickPage={onClickPage}
                    perPage={perPage}
                    showChangePerPage={false}
                />
            </div>
        </div>
    );
}
